import type { Item, Props } from './types';

export const ITEM_ID_ALL = 0;

/**
 * Выбран ли элемент
 */
export const isSelected = (modelValue: Props['modelValue'], item: Item, checkNameForNullId = true) => {
	if (checkNameForNullId && item.id === null) {
		if (Array.isArray(modelValue)) {
			return modelValue.some(itemSelected => itemSelected.id === item.id && itemSelected.name === item.name);
		} else {
			return item.name === modelValue.name;
		}
	}

	if (Array.isArray(modelValue)) {
		return modelValue.some(itemSelected => itemSelected.id === item.id);
	} else {
		return item.id === modelValue.id;
	}
};
